<template>
  <div
    :class="`flex ${errors?.length !== 0 ? 'justify-between' : 'justify-end'}`"
  >
    <div
      class="input-errors motion-safe:animate-errorBlink"
      v-for="(err, i) of errors"
      :key="i"
    >
      <small v-if="i === 0" id="error-msg" class="text-h-error-400">
        <slot name="msg">
          {{ err.$message }}
        </slot>
      </small>
    </div>
    <span v-if="maxLength" class="text-xs mt-1">
      {{ actualLength }}/{{ maxLength }}
    </span>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "errors",
  props: {
    errors: {
      type: Array,
      default: [],
    },
    maxLength: Number,
    actualLength: {
      type: Number,
      default: 0,
    },
  },
});
</script>
